import React, { useState, useMemo, useEffect } from "react";

import { PlusOutlined } from "@ant-design/icons";
import { get } from "lodash";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { FiSearch } from "react-icons/fi";
import More from "shared/components/More";
import NextPreviousFooter from "shared/components/NextPreviousFooter";
import Notification from "shared/components/Notification";
import Product from "shared/components/Product";
import SearchInput from "shared/components/SearchInput";
import { StepStore } from "shared/components/Tab";
import { DEFAULT_VALUES, NAME_SPACES } from "shared/locals/constants";

import FoldersTitle from "../Common/FoldersTitle";
import { PRODUCT_DETAILS, OTHER_PRODUCT } from "../constants";
import "./styles.scss";

const Invoices = ({
  query: { data, loading },
  onLoadMore,
  setActiveStep,
  step: { changeTab, onBack },
  onChange,
  onNavigate,
}) => {
  const { t } = useTranslation(NAME_SPACES.NEW_FOLDER, {
    keyPrefix: "PRODUCTS",
  });
  const [filter, setFilter] = useState("");
  const [product, setProduct] = useState();
  const items = useMemo(() => get(data, "products.data", []), [data]);
  const count = useMemo(() => get(data, "products.count"), [data]);
  const filtredItems = useMemo(
    () =>
      items.filter(
        ({ productRef, productBrand, productCode, productDesc }) =>
          (productRef || "").toLowerCase().includes(filter.toLowerCase()) ||
          (productBrand || "").toLowerCase().includes(filter.toLowerCase()) ||
          (productCode || "").toLowerCase().includes(filter.toLowerCase()) ||
          (productDesc || "").toLowerCase().includes(filter.toLowerCase()),
      ),
    [items, filter],
  );

  useEffect(() => {
    if (product?.openFolderNumber) {
      Notification.warning({
        duration: DEFAULT_VALUES.NOTIFICATION_DURATION,
        message: t("EXISTING_FOLDER"),
        btn: (
          <p onClick={onNavigate(product.openFolderNumber)}>
            {t("ACCESS_TO_FOLDER")}
          </p>
        ),
      });
    }
  }, [product?.openFolderNumber]);

  return (
    <>
      <div className={"newfolder--wrapper--content"}>
        <FoldersTitle title={t("TITLE")} subTitle={t("SUB_TITLE")} />
        <div className={"newfolder--wrapper--content--search"}>
          <div className={"newfolder--wrapper--content--search--input"}>
            <SearchInput
              label={t("SEARCH")}
              icon={<FiSearch color="#C4CDCB" size={24} />}
              onChange={(e) => {
                setFilter(e.target.value);
              }}
            />
          </div>
          <div className={"newfolder--wrapper--content--search--result"}>
            <div className={"more--product--card--wrap"}>
              <div className={"more--product--card--wrap--left"}>
                <PlusOutlined size={50} className="iconProduct" />
              </div>
              <div className={"more--product--card--wrap--right"}>
                <h3 onClick={() => changeTab(OTHER_PRODUCT)}>{t("ADD")}</h3>
              </div>
            </div>
            <Product
              items={filtredItems}
              type={"listProduct"}
              onClick={(_data) => {
                setProduct(_data);
              }}
            />
            <More
              title={t("MORE")}
              onClick={onLoadMore}
              visible={items.length < count}
              loading={loading}
            />
          </div>
        </div>
      </div>
      <NextPreviousFooter
        onPreviousClick={() => {
          onBack();
          setActiveStep(0);
        }}
        previousEnabled={true}
        onNextClick={() => {
          onChange(product);
          setActiveStep(2);
          changeTab(PRODUCT_DETAILS);
        }}
        nextEnabled={!!product && !product?.openFolderNumber}
      />
    </>
  );
};

Invoices.propTypes = {
  query: PropTypes.shape({
    data: PropTypes.shape({
      rules: PropTypes.shape({
        masks: PropTypes.array,
      }),
    }),
    loading: PropTypes.bool.isRequired,
  }).isRequired,
  onLoadMore: PropTypes.func.isRequired,
  setActiveStep: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  setFilter: PropTypes.func.isRequired,
  step: PropTypes.shape({
    changeTab: PropTypes.func.isRequired,
    onBack: PropTypes.func.isRequired,
  }).isRequired,
  onNavigate: PropTypes.func.isRequired,
};

Invoices.defaultProps = {};

export default StepStore(Invoices);
